import { Chevron } from "components/icons/chevron";
import React from "react";
import { CocoCallMeBack } from "../../assets/coco-call-me-back";
import {
  CMBCTAWrapper,
  CMBCTAContainer,
  CTAMessageHeading,
  CTAMessageSubHeading,
  StyledChevron
} from "./kelas-live-cmb-cta.styles";
import { KelasLiveCMBStages } from "../kelas-live-cmb.types";
import trackEvent from "services/mixpanel/mixpanel";
import { kelasLiveEvents } from "services/mixpanel/kelas-live-events";
import { PhoneCall } from "components/kelas-live/assets/phone-call";

const KelasLiveCMBCTA: React.FC<{
  onGoingClassExists: boolean;
  handleOnClick: (stage: KelasLiveCMBStages) => void;
}> = ({ onGoingClassExists, handleOnClick }) => {
  const handleCTAClick = () => {
    handleOnClick(KelasLiveCMBStages.SHOW_INFO_STAGE);
    trackEvent({
      eventName: kelasLiveEvents.contactKakakSiagaClicked,
      payload: {
        eventSource: "website",
        isClassOngoing: onGoingClassExists
      }
    });
  };

  return (
    <CMBCTAWrapper>
      <CMBCTAContainer>
        <CocoCallMeBack width={35} height={35} />
        <CTAMessageHeading>Error pas mau masuk kelas?</CTAMessageHeading>
        <CTAMessageSubHeading
          onClick={handleCTAClick}
          aria-label="Chat Kakak Siaga di WA"
        >
          <PhoneCall />
          Chat Kakak Siaga di WA
        </CTAMessageSubHeading>
        <StyledChevron>
          <Chevron direction={"right"} width={16} height={16} />
        </StyledChevron>
      </CMBCTAContainer>
    </CMBCTAWrapper>
  );
};

export { KelasLiveCMBCTA };
